import React, { useEffect, useState } from "react";
import { FAQPage, WithContext } from "schema-dts";

import { JSONLDComponent } from "../JSONLDComponent";

import {
  Category,
  FrequentlyAskedQuestion,
} from "~/Applet/RentalCategoriesFAQAccordion/types";
import { useOmnichannelApi } from "~/OmnichannelApi";

export const FAQSchema: React.FC = () => {
  const api = useOmnichannelApi();
  const [rentalCategoriesFAQs, setRentalCategoriesFAQs] =
    useState<FrequentlyAskedQuestion[]>();

  const match = window.location.pathname.match(
    /^\/rent\/categories\/([^/]+)$/i
  );
  const categorySlug = match?.[1];

  useEffect(() => {
    if (!categorySlug) {
      return;
    }
    api["static.webflow.collections.items.get"]({
      collection_slug: "categories",
      path_name: "items",
      item_slug: categorySlug,
      file_type: "json",
    }).then((res) => {
      const collectionData = res.data as Category;

      const rentalCategoriesFAQsData: FrequentlyAskedQuestion[] =
        collectionData.frequently_asked_questions;
      setRentalCategoriesFAQs(rentalCategoriesFAQsData);
    });
  }, [categorySlug]);

  if (!categorySlug || !rentalCategoriesFAQs?.length) {
    return null;
  }

  const stripHtml = (input: string): string => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(input, "text/html");

    return doc.body.textContent || "";
  };

  const FAQData: WithContext<FAQPage> = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: rentalCategoriesFAQs.map((faq) => ({
      "@type": "Question",
      name: stripHtml(faq.name),
      acceptedAnswer: {
        "@type": "Answer",
        text: stripHtml(faq.answer),
      },
    })),
  };

  return <JSONLDComponent structuredData={FAQData} />;
};
